module.exports = __webpack_public_path__ + "static/media/structured-content-icon.764794f5.svg";